import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-liste-rejeter',
  templateUrl: './liste-rejeter.component.html',
  styleUrls: ['./liste-rejeter.component.css']
})
export class ListeRejeterComponent implements OnInit {

  valide: any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Rejeté",
      "validation" : "26/06/2020 12:35:00"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur" : 1256,
      "etat" : "Rejeté",
      "validation" : "26/06/2020 16:00:00"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur" : 1254,
      "etat" : "Rejeté",
      "validation" : "26/06/2020 15:00:00",
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Rejeté",
      "validation" : "26/06/2020 15:00:00"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Rejeté",
      "validation" : "26/06/2020 15:00:00"
    },
  ];

  valideCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur', header: 'Matricule OP'},
    {field: 'etat', header: 'Etat'},
    {field: 'validation', header: 'Date du rejet'}
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
